import React, { useMemo } from "react";
import { calculateSustainabilityAverages } from "../utils/sustainabilityAverages";
import { useTranslation } from "../hooks/useTranslation";

const SustainabilityValue = (props) => {
  const { t: translate } = useTranslation();
  const component = useMemo(() => props.component || {}, [props.component]);

  const co2ePerKg = useMemo(() => {
    const v = parseFloat(component.co2e_equivalent);
    return Number.isFinite(v) ? parseFloat(v.toFixed(3)) : null;
  }, [component.co2e_equivalent]);

  // Prefer backend averages only if they are valid numbers; otherwise calculate from raw scores
  const hasValidPrecalc = [component.environment_average, component.health_average, component.social_average]
    .some((v) => typeof v === 'number' && !Number.isNaN(v));

  const averages = hasValidPrecalc
    ? {
        environment_average: typeof component.environment_average === 'number' ? component.environment_average : 0,
        health_average: typeof component.health_average === 'number' ? component.health_average : 0,
        social_average: typeof component.social_average === 'number' ? component.social_average : 0,
      }
    : calculateSustainabilityAverages(component);
  

  
  const getImage = (name) => {
    if (name === "CO2e") {
      return `${process.env.PUBLIC_URL}/assets/icons/Klimat.png`;
    }
    return `${process.env.PUBLIC_URL}/assets/icons/${getImageName(name)}.png`;
  };
  
  const getImageName = (name) => {
    switch (name) {
      case "environment":
        return "Miljo";
      case "health":
        return "Halsa";
      case "social":
        return "Rattvisa";
      case "CO2e":
        return "CO2e";
      default:
        return name.charAt(0).toUpperCase() + name.slice(1);
    }
  };
  
  const getDisplayValue = (val) => {
    return val !== null && val !== undefined ? val : "-";
  };
  
  const getScoreColor = (value) => {
    if (value === null || value === undefined) return "text-gray-400";
    if (value >= 80) return "text-green-600 font-semibold";
    if (value >= 60) return "text-yellow-600 font-semibold";
    if (value >= 40) return "text-orange-600 font-semibold";
    return "text-red-600 font-semibold";
  };
  
  // Define the three categories to display + CO2e/kg (direct)
  const categories = [
    { key: 'environment', label: 'Miljö', value: averages.environment_average },
    { key: 'health', label: 'Hälsa', value: averages.health_average },
    { key: 'social', label: 'Rättvisa', value: averages.social_average },
    { key: 'CO2e', label: 'CO2e', value: co2ePerKg }
  ];
  
  return (
    <div className="space-y-1">
      {categories.map((category) => {
        const grayScaleClass = category.value === null || category.value === 0 ? "grayscale opacity-50" : "";
        const scoreColor = getScoreColor(category.value);
        
        return (
          <div key={category.key} className="flex items-center justify-between py-1">
            <div className="flex items-center space-x-2">
              <img
                className={`${category.key === "CO2e" ? "w-5 h-5" : "w-4 h-4"} ${grayScaleClass}`}
                src={getImage(category.key)}
                alt={category.label}
              />
              <span className="text-sm">{translate(category.label)}{category.key === "CO2e" ? " kg/kg" : ""}</span>
            </div>
            <div className={`${category.key === "CO2e" ? "text-gray-600 font-normal" : scoreColor} text-sm`}>
              {getDisplayValue(category?.value)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SustainabilityValue;

